import React, { useState, useEffect } from "react";
import { Upload, message, Modal } from "antd";
import AIReportUpload from "./AIReportUpload";
import ReportUploadProgress from "./ReportUploadProgress";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../PageRouting/AppRoutes";
import dentalcareimg2 from "../../Assets/Images/dentalcare/dentalcareimg2.png";
import dentalcareimg3 from "../../Assets/Images/dentalcare/dentalcareimg3.png";
import dentalcareimg4 from "../../Assets/Images/dentalcare/dentalcareimg4.png";
import dentalcareimg5 from "../../Assets/Images/dentalcare/Gum.png";
import dentalcareimg6 from "../../Assets/Images/dentalcare/innercheek.png";
import dentalcareimg7 from "../../Assets/Images/dentalcare/tongue.png";
import dentalcareimg8 from "../../Assets/Images/dentalcare/lips.png";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const log = (event, payload) => {
    try { console.log("[DentalCareUpload]", event, payload || ""); } catch { }
};
const resolveFileType = (selectedFile) => {
    const mimeToExt = (m) => (m === "image/png" ? ".png" : (m === "image/jpeg" || m === "image/jpg") ? ".jpg" : "");
    const extFromName = selectedFile?.name?.includes(".") ? "." + selectedFile.name.split(".").pop().toLowerCase() : "";
    const ct = selectedFile?.type || "application/octet-stream";
    return extFromName || mimeToExt(ct);
};

export default function DentalUpload({ patientId,sourcechannel, createdBy, serviceName = "Oral Care", onStarted, initialVisible, onCloseInitial }) {
    const [file, setFile] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [requestId, setRequestId] = useState(null);
    const [uploadUrls, setUploadUrls] = useState([]);
    const [stage, setStage] = useState(initialVisible ? "instructions" : null);
    const [progress, setProgress] = useState(0);
    const [errorText, setErrorText] = useState("");
     const navigate = useNavigate();
    const hiddenFileInput1 = React.useRef(null);
    const hiddenFileInput2 = React.useRef(null);
    const hiddenFileInput3 = React.useRef(null);
    const hiddenFileInput4 = React.useRef(null);
    const hiddenFileInput5 = React.useRef(null);
    const hiddenFileInput6 = React.useRef(null);
    const hiddenFileInput7 = React.useRef(null);
    const [filePreview1, setFilePreview1] = useState("");
    const [filePreview2, setFilePreview2] = useState("");
    const [filePreview3, setFilePreview3] = useState("");
    const [filePreview4, setFilePreview4] = useState("");
    const [filePreview5, setFilePreview5] = useState("");
    const [filePreview6, setFilePreview6] = useState("");
    const [filePreview7, setFilePreview7] = useState("");
    const [fileObj1, setFileObj1] = useState(null);
    const [fileObj2, setFileObj2] = useState(null);
    const [fileObj3, setFileObj3] = useState(null);
    const [fileObj4, setFileObj4] = useState(null);
    const [fileObj5, setFileObj5] = useState(null);
    const [fileObj6, setFileObj6] = useState(null);
    const [fileObj7, setFileObj7] = useState(null);

    const endpointBase = process.env.REACT_APP_QUANTUMURL;

    useEffect(() => {
        if (initialVisible) {
            setStage("instructions");
            log("initial_modal_open");
        }
    }, [initialVisible]);

    const generateUploadUrl = async (ct, selectedFile) => {
        setProgress(10);
        try { localStorage.setItem("quantumUploadSession", JSON.stringify({ requestId: null, serviceName, progress: 10, checkedOnce: false })); } catch { }
        setStage("ai");
        log("ai_modal_open");
        const resolvedFileType = resolveFileType(selectedFile);
        console.log(patientId)
        const payload = {
            patientId,
            serviceName,
            files: [
                {
                    fileNumber: 1,
                    fileType: resolvedFileType,
                    contentType: ct,
                }
            ]
        };
        try {
            log("prepare_upload_start", payload);
            await delay(10000);
            const url = new URL("new_generate-resumable-url", endpointBase).toString();
            const res = await axios.post(url, payload, { headers: { "Content-Type": "application/json" } });
            const data = res.data;
            const rid = data?.request_id || data?.requestId || data?.requestid || data?.requestID || null;
            setRequestId(rid);
            setUploadUrls(data?.upload_urls || []);
            setProgress(50);
            try { 
                const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
                localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, requestId: rid, serviceName, progress: 50 })); 
            } catch { }
            setStage("progress");
            log("ai_modal_close");
            log("progress_modal_open");
            setErrorText("");
            log("prepare_upload_success", { requestId: rid });
            return { rid, urls: data?.upload_urls || [] };
        } catch (err) {
            setErrorText(String(err));
            message.error("Failed to prepare upload. Please try again.");
            setStage("ai");
            log("prepare_upload_error", { message: String(err) });
            localStorage.removeItem("quantumUploadSession");
            return Promise.reject(err);
        }
    };

    const generateUploadUrls = async (files) => {
        const filesPayload = [];
        if (files) {
            files.forEach((file, index) => {
                if (file) {
                    filesPayload.push({
                        fileNumber: index + 1,
                        fileType: resolveFileType(file),
                        contentType: file.type || "application/octet-stream"
                    });
                }
            });
        }
        if (!filesPayload.length) return Promise.reject(new Error("No files selected"));
        setProgress(10);
        localStorage.setItem("quantumUploadSession", JSON.stringify({ requestId: null, serviceName, progress: 10, checkedOnce: false }));
        setStage("ai");
        log("ai_modal_open");
        const payload = {
            patientId,
            serviceName,
            files: filesPayload
        };
        try {
            log("prepare_upload_start", payload);
            await delay(10000);
            const url = new URL("new_generate-resumable-url", endpointBase).toString();
            const res = await axios.post(url, payload, { headers: { "Content-Type": "application/json" } });
            const data = res.data;
            const rid = data?.request_id || data?.requestId || data?.requestid || data?.requestID || null;
            setRequestId(rid);
            setUploadUrls(data?.upload_urls || []);
            setProgress(50);
            try { 
                const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
                localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, requestId: rid, serviceName, progress: 50 })); 
            } catch { }
            setStage("progress");
            log("ai_modal_close");
            log("progress_modal_open");
            setErrorText("");
            log("prepare_upload_success", { requestId: rid });
            return { rid, urls: data?.upload_urls || [] };
        } catch (err) {
            setErrorText(String(err));
            message.error("Failed to prepare upload. Please try again.");
            setStage("ai");
            log("prepare_upload_error", { message: String(err) });
            localStorage.removeItem("quantumUploadSession");
            return Promise.reject(err);
        }
    };

    const uploadFiles = async (urlsParam, filesParam) => {
        const urls = Array.isArray(urlsParam) ? urlsParam : uploadUrls;
        const useFiles = Array.isArray(filesParam) ? filesParam : [file].filter(Boolean);
        if (!urls.length || !useFiles.length) return;
        setStage("progress");
        log("progress_modal_open");
        for (let i = 0; i < useFiles.length; i++) {
            const f = useFiles[i];
            if (!f) continue;
            
            if (!urls[i] || !urls[i].url) {
                log("upload_put_error", { message: "Missing upload URL", index: i });
                continue;
            }

            const ct = f?.type || "application/octet-stream";
            const cleanUrl = urls[i].url.trim();

            try {
                log("upload_put_start", { url: cleanUrl, contentType: ct, index: i });
                await delay(1000);
                await axios.put(cleanUrl, f, {
                    headers: { "Content-Type": ct },
                    timeout: 60000,
                    onUploadProgress: (evt) => {
                        if (evt && typeof evt.loaded === "number" && typeof evt.total === "number" && evt.total > 0) {
                            const fraction = evt.loaded / evt.total;
                            const pct = 50 + Math.min(30, Math.round(((i + fraction) / useFiles.length) * 30));
                            setProgress(pct);
                            try {
                                const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
                                localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: pct }));
                            } catch { }
                            log("upload_progress", { percent: pct, index: i });
                        }
                    },
                });
            } catch (err) {
                setErrorText(String(err));
                message.error("Upload failed. Please check your network and retry.");
                log("upload_put_error", { message: String(err), index: i });
                localStorage.removeItem("quantumUploadSession");
                throw err;
            }
        }
        setProgress(80);
        try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 80 })); } catch { }
        setErrorText("");
        log("upload_put_success");
    };

    const startBatchUpload = async () => {
        const files = [fileObj1, fileObj2, fileObj3, fileObj4, fileObj5, fileObj6, fileObj7];
        const validFiles = files.filter(Boolean);
        if (!validFiles.length) { message.error("Please upload at least one image."); return; }
        try {
            const { rid, urls } = await generateUploadUrls(files);
            await uploadFiles(urls, validFiles);
            await checkUploaded(rid, 7);
        } catch (err) {
            setProgress(0);
            setStage("ai");
            try { localStorage.removeItem("quantumUploadSession"); } catch { }
        }
    };

    const readFileAsDataURL = (f) => new Promise((resolve, reject) => { const r = new FileReader(); r.onload = () => resolve(r.result); r.onerror = reject; r.readAsDataURL(f); });
    const handleSlotChange = async (e, idx) => {
        const f = e.target.files && e.target.files[0];
        if (!f) return;
        const isImage = f.type === "image/png" || f.type === "image/jpeg" || f.type === "image/jpg";
        if (!isImage) { message.error("Only PNG, JPG, or JPEG images are allowed!"); return; }
        const isLt5MB = f.size / 1024 / 1024 < 5;
        if (!isLt5MB) { message.error("Image must be smaller than 5MB!"); return; }
        const dataUrl = await readFileAsDataURL(f);
        if (idx === 1) { setFilePreview1(dataUrl); setFileObj1(f); }
        else if (idx === 2) { setFilePreview2(dataUrl); setFileObj2(f); }
        else if (idx === 3) { setFilePreview3(dataUrl); setFileObj3(f); }
        else if (idx === 4) { setFilePreview4(dataUrl); setFileObj4(f); }
        else if (idx === 5) { setFilePreview5(dataUrl); setFileObj5(f); }
        else if (idx === 6) { setFilePreview6(dataUrl); setFileObj6(f); }
        else if (idx === 7) { setFilePreview7(dataUrl); setFileObj7(f); }
    };
    const uploadFile = async (urlsParam, fileParam) => {
        const urls = Array.isArray(urlsParam) ? urlsParam : uploadUrls;
        const useFile = fileParam || file;
        if (!urls.length || !useFile) return;
        setStage("progress");
        log("progress_modal_open");
        const ct = useFile?.type || "application/octet-stream";
        try {
            const cleanUrl = urls[0]?.url?.trim();
            if (!cleanUrl) throw new Error("Missing upload URL");

            log("upload_put_start", { url: cleanUrl, contentType: ct });
            await delay(10000);
            await axios.put(cleanUrl, useFile, {
                headers: { "Content-Type": ct },
                timeout: 60000,
                onUploadProgress: (evt) => {
                    if (evt && typeof evt.loaded === "number" && typeof evt.total === "number" && evt.total > 0) {
                        const fraction = evt.loaded / evt.total;
                        const pct = 50 + Math.min(30, Math.round(fraction * 30));
                        setProgress(pct);
                        try {
                            const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
                            localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: pct }));
                        } catch { }
                        log("upload_progress", { percent: pct });
                    }
                },
            });
            setProgress(80);
            try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 80 })); } catch { }
            setErrorText("");
            log("upload_put_success");
        } catch (err) {
            setErrorText(String(err));
            // message.error("Upload failed. Please check your network and retry.");
            log("upload_put_error", { message: String(err) });
            throw err;
        }
    };

    const checkUploaded = async (ridOverride, countOverride) => {
        const rid = ridOverride || requestId;
        if (!rid) return;
        setProgress((p) => (p < 90 ? 90 : p));
        try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 90 })); } catch { }
        const url = new URL("check-uploaded-files", endpointBase).toString();
        const body = {
            requestId: rid,
            serviceName,
            sourceChannel: sourcechannel,  
        createdBy: createdBy,
            signedUrlCount: typeof countOverride === "number" ? countOverride : 1,
            fileType: resolveFileType(file || fileObj1 || fileObj2 || fileObj3 || fileObj4 || fileObj5 || fileObj6 || fileObj7),
        };
        try {
            log("verify_start", { requestId: rid });
            await delay(10000);
            const res = await axios.post(url, body, { headers: { "Content-Type": "application/json", accept: "application/json" } });
            const data = res.data;
            log("verify_response", data);
            if (data) {
                setProgress(100);
                try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 100 })); } catch { }
                setErrorText("");
                log("verify_success", { requestId: rid });
            } else {
                setErrorText("Upload verification failed.");
                message.error("Upload verification failed.");
                log("verify_failed", { status: data?.status });
            }
        } catch (err) {
            setErrorText(String(err));
            message.error("Failed to verify upload.");
            log("verify_error", { message: String(err) });
            throw err;
        }
    };

    const beforeUpload = (f) => {
        const isImage = f.type === "image/png" || f.type === "image/jpeg" || f.type === "image/jpg";
        if (!isImage) { message.error("Only PNG, JPG, or JPEG images are allowed!"); return false; }
        const isLt5MB = f.size / 1024 / 1024 < 5;
        if (!isLt5MB) { message.error("Image must be smaller than 5MB!"); return false; }
        const reader = new FileReader();
        reader.onload = () => { setUploadedImage(reader.result); };
        reader.readAsDataURL(f);
        setFile(f);
        log("file_selected", { name: f?.name, type: f?.type, size: f?.size });
        setStage("ai");
        log("initial_modal_close");
        if (typeof onStarted === "function") onStarted();
        const ct = f.type || "application/octet-stream";
        generateUploadUrl(ct, f)
            .then(({ rid, urls }) => uploadFile(urls, f).then(() => rid))
            .then((rid) => checkUploaded(rid))
            .catch((err) => { setProgress(0); setStage("ai"); try { localStorage.removeItem("quantumUploadSession"); } catch { } });
        return false;
    };

    return (
        <>
            <Modal
                open={stage === "instructions"}
                onCancel={() => { setStage(null); log("initial_modal_cancel"); if (typeof onCloseInitial === "function") onCloseInitial(); }}
                footer={null}
                centered
                width={1200}
                style={{ maxWidth: '100vw' }}
            >
                <div className=" bg-white py-6">
                    <div className="flex flex-col items-center w-full bg-lightBlue p-4 sm:p-6 md:p-10 rounded-md sm:mb-10 mb-2">
                        {/* Centered Heading */}
                        <h2
  className="text-2xl md:text-3xl font-bold text-center mb-10"
  style={{
    background: "var(--primary-gradient)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  }}
>
  How to capture <span>clear images</span>?
</h2>

                        {/* Content: Points + Images */}
                        <div className="flex flex-col sm:flex-row w-full max-w-6xl " >
                            {/* Left Side - Instructions */}
                            <div className="w-full sm:w-1/2">
                                <ul className="list-disc mt-2 text-gray-700 space-y-2 pl-5">
                                    <li><strong>Use natural lighting</strong> to avoid shadows and glare</li>
                                    <li>Hold the camera steady and ensure the image is <strong>clear and focused</strong></li>
                                    <li>Slightly tilt your head for better visibility of upper and lower teeth</li>
                                    <li>Gently pull your cheek or lip outward to expose the area</li>
                                    <li>Stick out your <strong>tongue fully</strong> to capture both the top and underside</li>
                                    <li>Avoid <strong>filters or image alterations</strong> for accurate AI analysis</li>
                                </ul>
                            </div>

                            {/* Right Side - Images */}
                            <div className="w-full sm:w-1/2 flex flex-col md:flex-row space-x-2 sm:space-x-10 items-center justify-center mt-6">
                                {/* Correct Image */}
                                <div className="flex flex-col items-center flex-1">
                                    <img
                        src={`${process.env.REACT_APP_IMG_BASEURL}d2c-web/Teeth1.png`}

                        alt="Correct Image"
                        className="rounded-md object-cover "
                      />
                                    <span className="text-secondaryColor mb-2 sm:mb-0 md:text-2xl text-base mt-2">
                                        ✓ <span className="text-textGray">Correct image</span>
                                    </span>
                                </div>

                                {/* Incorrect Image */}
                                <div className="flex flex-col items-center flex-1">
                                    <img
                        src={`${process.env.REACT_APP_IMG_BASEURL}d2c-web/Smile2.png`}
                        alt="Incorrect Image"
                        className="rounded-md object-cover"
                        style={{ objectPosition: 'right center' }}
                      />
                                    <span className="text-danger md:text-2xl text-base mt-2">
                                        ✗ <span className="text-textGray">Incorrect image</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mx-auto max-w-[90%] md:max-w-[90%]">
                   <h2
                        className="text-center text-xl md:text-4xl font-bold leading-normal mb-6"
                        style={{
                            background: "var(--primary-gradient)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            paddingBottom: "4px" // prevents cut
                        }}
                        >
                        Upload photos and get an instant{" "}
                        <span>oral health report</span>
                    </h2>
                    <h3
                        className="text-center text-lg md:text-2xl font-semibold mt-6 mb-4"
                        style={{
                            background: "var(--primary-gradient)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            paddingBottom: "4px" // prevents cut
                        }}
                        >
                        Dental Care
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 place-items-center">
                        {[{
                            title: "Front teeth",
                            desc: "Incisors & Canines",
                            file: filePreview1,
                            img: dentalcareimg2,
                            click: () => hiddenFileInput1.current?.click(),
                            hiddenRef: hiddenFileInput1,
                            change: (e) => handleSlotChange(e, 1)
                        }, {
                            title: "Upper teeth",
                            desc: "Molars & Premolars",
                            file: filePreview2,
                            img: dentalcareimg3,
                            click: () => hiddenFileInput2.current?.click(),
                            hiddenRef: hiddenFileInput2,
                            change: (e) => handleSlotChange(e, 2)
                        }, {
                            title: "Lower teeth",
                            desc: "Molars & Premolars",
                            file: filePreview3,
                            img: dentalcareimg4,
                            click: () => hiddenFileInput3.current?.click(),
                            hiddenRef: hiddenFileInput3,
                            change: (e) => handleSlotChange(e, 3)
                        }].map((item, index) => (
                            <div key={index} className="flex flex-col items-center text-center w-full sm:w-[270px]">
                                <img className="w-full aspect-square sm:w-[256px] sm:h-[256px] object-cover rounded-xl" src={item.file || item.img} alt={item.title} />
                                <h5 className="text-[#373737] md:text-lg  text-sm font-semibold mt-2">{item.title}</h5>
                                <p className="text-textGray whitespace-nowrap sm:whitespace-normal text-sm mb-2">{item.desc}</p>
                                <button className="text-[#067ad0]" onClick={item.click}>{item.file ? 'Upload another' : 'Upload photo'}</button>
                                <input ref={item.hiddenRef} type="file" accept="image/jpeg, image/png" onChange={item.change} className="hidden" />
                            </div>
                        ))}
                    </div>
                    <h3
                        className="text-center text-lg md:text-2xl font-semibold mt-6 mb-4"
                        style={{
                            background: "var(--primary-gradient)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            paddingBottom: "4px" // prevents cut
                        }}
                        >
                        Oral Care
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 place-items-center">
                        {[{
                            title: "Gums",
                            desc: "Upper or Lower",
                            file: filePreview4,
                            img: dentalcareimg5,
                            click: () => hiddenFileInput4.current?.click(),
                            hiddenRef: hiddenFileInput4,
                            change: (e) => handleSlotChange(e, 4)
                        }, {
                            title: "Inner cheeks",
                            desc: "Left or right side",
                            file: filePreview5,
                            img: dentalcareimg6,
                            click: () => hiddenFileInput5.current?.click(),
                            hiddenRef: hiddenFileInput5,
                            change: (e) => handleSlotChange(e, 5)
                        }, {
                            title: "Tongue",
                            desc: "Top, bottom or side",
                            file: filePreview6,
                            img: dentalcareimg7,
                            click: () => hiddenFileInput6.current?.click(),
                            hiddenRef: hiddenFileInput6,
                            change: (e) => handleSlotChange(e, 6)
                        }, {
                            title: "Inner lips",
                            desc: "Upper or lower lip inside",
                            file: filePreview7,
                            img: dentalcareimg8,
                            click: () => hiddenFileInput7.current?.click(),
                            hiddenRef: hiddenFileInput7,
                            change: (e) => handleSlotChange(e, 7)
                        }].map((item, index) => (
                            <div key={index} className="flex flex-col items-center text-center w-full sm:w-[270px]">
                                <img className="w-full aspect-square sm:w-[256px] sm:h-[256px] object-cover rounded-xl" src={item.file || item.img} alt={item.title} />
                                <h5 className="text-[#373737] md:text-lg  text-sm font-semibold mt-2">{item.title}</h5>
                                <p className="text-textGray whitespace-nowrap sm:whitespace-normal text-sm mb-2">{item.desc}</p>
                                <button className="text-[#067ad0]" onClick={item.click}>{item.file ? 'Upload another' : 'Upload photo'}</button>
                                <input ref={item.hiddenRef} type="file" accept="image/jpeg, image/png" onChange={item.change} className="hidden" />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="text-center mt-5">
                    <button
                    className="px-3 py-2 bg-[#004276] hover:bg-[#003360] text-white text-sm rounded"
                    onClick={startBatchUpload}
                    >
                    Get AI report
                    </button>
                </div>
            </Modal>
            {stage !== "instructions" && (
                <Upload showUploadList={false} accept=".png,.jpg,.jpeg" beforeUpload={beforeUpload}>
                    <button className="px-3 py-1 mt-1 bg-[#004276] hover:bg-[#003360] text-White text-sm rounded">Upload</button>
                </Upload>
            )}
            <AIReportUpload
                solutionType='oral_care'
                visible={stage === "ai"}
                customHeaderTitle={errorText ? "Image upload failed !" : undefined}
                customHeaderColor={errorText ? "#FA0505" : undefined}
                customTitle={errorText ? "Oops, we couldn’t upload your image. Please check your connection and try uploading again so our AI can generate your report." : undefined}
                customDescription={errorText ? "Your image upload was unsuccessful-please upload the photo again !" : undefined}
                customDescriptionColor={errorText ? "#FA0505" : undefined}
                customButtonText={errorText ? "Upload Again" : undefined}
                onCancel={() => {
                    setStage(null);
                    log("ai_modal_cancel");
                    if (typeof onCloseInitial === "function") onCloseInitial();
                    // setProgress(0);
                    // setRequestId(null);
                    // setUploadUrls([]);
                    setErrorText("");
                    // try { localStorage.removeItem("quantumUploadSession"); } catch { }
                    try { 
                        const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
                        localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, checkedOnce: true })); 
                    } catch { }
                }}
                onExplore={() => {
  if (errorText) { setStage("instructions"); setErrorText(""); return; }
  try { 
    const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
    localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, checkedOnce: true })); // ✅ keeps existing requestId, progress
  } catch {}
  navigate("/", { state: { quantumUpload: { requestId, serviceName, progress: progress || 10 } } });
}}
                onWait={() => { setStage("progress"); log("ai_modal_wait"); log("progress_modal_open"); }}
            />
            <ReportUploadProgress
                solutionType='oral_care'
                visible={stage === "progress"}
                onCancel={() => {
                    setStage(null);
                    log("progress_modal_cancel");
                    if (typeof onCloseInitial === "function") onCloseInitial();
                    setProgress(0);
                    setRequestId(null);
                    setUploadUrls([]);
                    setErrorText("");
                    try { localStorage.removeItem("quantumUploadSession"); } catch { }
                }}
                progress={progress}
                imageSrc={progress >= 80 && (uploadedImage || filePreview1 || filePreview2 || filePreview3 || filePreview4 || filePreview5 || filePreview6 || filePreview7) ? (uploadedImage || filePreview1 || filePreview2 || filePreview3 || filePreview4 || filePreview5 || filePreview6 || filePreview7) : undefined}
                title={errorText ? "Upload failed" : undefined}
                description={errorText ? errorText : undefined}
                analyzingText={errorText ? "Please close and retry" : undefined}
               onView={() => {
                navigate("/aireports", { state: { tab: "oral_care" } });
                log("progress_modal_view_report", { tab: "oral_care" });
                localStorage.removeItem("quantumUploadSession");
                }}
            />
        </>
    );
}
